import { CLASS_NAMES } from '../../utils/constants'
import GameObject from './GameObject'

export default class Wall extends GameObject {
  constructor(id, level) {
    super({
      id,
      isRigid: true,
      isBreakable: false,
      isFlat: true,
      isPickable: false,
      isCrushable: false,
      level
    })
    this.strength = 20
  }
}

Wall.className = CLASS_NAMES.WALL
